export const MINI_APP_LINK = "https://t.me/askloyal_tgbot/app";
